import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M40 0c8.837 0 16 7.163 16 16v24c0 8.837-7.163 16-16 16H16C7.163 56 0 48.837 0 40V16C0 7.163 7.163 0 16 0zM24.92 18c-1.55 0-2.81 1.25-2.81 2.8v.74c-1.21.64-2.05 1.9-2.05 3.37V36.5h-1.31a.749.749 0 1 0 0 1.5h18.5a.749.749 0 1 0 0-1.5h-1.31V24.91c0-1.47-.84-2.73-2.05-3.37v-.74c0-1.55-1.26-2.8-2.81-2.8zM28 33.88c.72 0 1.31.59 1.31 1.31v1.31h-2.62v-1.31c0-.72.59-1.31 1.31-1.31m-2.06-5.09c.42 0 .75.33.75.75v1.03c0 .41-.33.75-.75.75h-1.02a.75.75 0 0 1-.75-.75v-1.03c0-.42.33-.75.75-.75zm5.14 0c.42 0 .75.33.75.75v1.03c0 .41-.33.75-.75.75h-1.02a.75.75 0 0 1-.75-.75v-1.03c0-.42.33-.75.75-.75zm-5.14-4.63c.42 0 .75.34.75.75v1.03c0 .41-.33.75-.75.75h-1.02a.75.75 0 0 1-.75-.75v-1.03c0-.41.33-.75.75-.75zm5.14 0c.42 0 .75.34.75.75v1.03c0 .41-.33.75-.75.75h-1.02a.75.75 0 0 1-.75-.75v-1.03c0-.41.33-.75.75-.75zm0-4.66c.72 0 1.31.58 1.31 1.3v.28h-8.78v-.28c0-.72.59-1.3 1.31-1.3z"
    }, null, -1)
  ]))]))
}
export default { render: render }